import { AvailableTicket, IFinalEvent } from "types/event"

//TODO: improve this function by just proessing the tickets not the whole event.
//TODO: maybe extract to a custom hook.
export const getLowestTicketPrice = (event: IFinalEvent) => {
    const tickets = event?.availableTickets as AvailableTicket[] | undefined

    if (!tickets || tickets.length === 0) {
        return 0
    }

    let lowestPrice = Number.POSITIVE_INFINITY

    for (const ticket of tickets) {
        if (!ticket) continue

        const hasDiscount =
            Boolean(ticket.discount) &&
            typeof ticket.discount.current_value === "number" &&
            ticket.discount.current_value > 0

        const effectivePrice = hasDiscount
            ? ticket.discount.current_value
            : ticket.price

        if (
            typeof effectivePrice === "number" &&
            !Number.isNaN(effectivePrice)
        ) {
            lowestPrice = Math.min(lowestPrice, effectivePrice)
        }
    }

    if (!Number.isFinite(lowestPrice) || lowestPrice < 0) {
        return 0
    }

    return lowestPrice
}

export const hasMultiplePrices = (event: IFinalEvent) => {
    if (event?.availableTickets && event?.availableTickets?.length > 1) {
        // check if all tickets have the same price
        const prices = event?.availableTickets?.map(
            (ticket: AvailableTicket) => ticket?.price
        ) as number[]

        return new Set(prices).size !== 1
    }

    return false
}
